export default __webpack_public_path__ + "static/media/credit-cards.27f91223.svg";